<template>
  <div>
			<!-- <iframe :src="frameUrl"
			@load="onIframeLoad"
			        @error="onIframeError"
					sandbox="allow-same-origin allow-scripts" target="_top"
					v-if="showPage" class="page-frame" /> -->
    <div class="page-close" @click="showPage=false" v-if="showPage">
      <img src="../assets/img/close.png" />
    </div>
    <div class='top'>选择人员</div>
    <div class='record'>
      <div v-for='(item, index) in recordList' :key='index' class='record-list-item'>
        <div>{{ item.name }}</div>
      </div>
    </div>
    <div class="url-mask">
      <div class="mask">
        <div class="mask-close" @click="onCloseDetail">
          <img src="../assets/img/close.png" />
        </div>
        <div class='url-title'>问卷列表</div>
        <div class="url-lists">
          <div v-for="(item, index) in ktwjUrlList" :key="index" class="url-list" @click="goUrl(item, false)">
            <div v-if="item.wjUrl == null || item.wjUrl == ''" class="list-title">
              {{ item.title }}
            </div>
            <div v-if="item.wjUrl != null && item.wjUrl != ''" class="list-title">
              <span v-if='item.type == 1'> {{ item.title }}</span>
              <a v-if='item.type == 0'> {{ item.title }}</a>
            </div>
            <div v-if="item.wjUrl != null && item.wjUrl != ''">
              <span v-if='item.type == 1'>已完成</span>
              <a v-if='item.type == 0'>未完成</a>
            </div>
          </div>
        </div>
        
        <div v-if="ktwjUrlList.length == 0" class="url-list">
          暂无问卷
        </div>
        <div class="info-text">
          问卷状态每半小时更新，如您刚半小时内已答完，可忽略上面“未完成”状态，半小时后再查询
        </div>
      </div>
    </div>
    <div class='r-query'>
      <button class="btn">通过 姓名+身份证/电话/学号 查询</button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'list',
  data() {
    return {
      recordList: [],
      openId: '',
      frameUrl: '',
      ktwjUrlList: [],
      showPage: false,
      uid: '',
      
      // zyUrl: 'https://test.yjkok.com/syndrome/#/questionResult',
      // tzUrl: 'https://test.yjkok.com/child-physique/#/questionResult',
      // zyListUrl: 'https://test.yjkok.com/syndrome/#/questionList',
      // tzListUrl: 'https://test.yjkok.com/child-physique/#/questionList',
      
      /*
      zyUrl: 'http://192.168.0.106:8081/#/questionResult',
      zyListUrl: 'http://192.168.0.106:8081/#/questionList',
      tzUrl: 'https://test.yjkok.com/child-physique/#/questionResult',
      tzListUrl: 'https://test.yjkok.com/child-physique/#/questionList',*/
      zyUrl: 'https://i.yjkok.com/syndrome/#/questionResult',
      tzUrl: 'https://i.yjkok.com/child-physique/#/questionResult',
      zyListUrl: 'https://i.yjkok.com/syndrome/#/questionList',
      tzListUrl: 'https://i.yjkok.com/child-physique/#/questionList',
    };
  },
  mounted() {
    this.recordList.push({ name: this.$route.query.queryName });
    this.openId = this.$route.query.openId;
    document.title = '问卷填写';
    this.uid = this.$route.query.queryId
    this.goQuery(this.$route.query.queryId);
	window.addEventListener('message', this.handleMessage);
  },
        beforeDestroy() {
          window.removeEventListener('message', this.handleMessage);
        },
  methods: {
	  loadIframe() {
	            if (!this.iframeUrl) return;
	            
	            this.currentUrl = this.iframeUrl;
	            this.loading = true;
	            this.statusMessage = '开始加载页面';
	            this.addLog(`开始加载: ${this.iframeUrl}`);
	          },
	          refreshIframe() {
	            if (!this.currentUrl) return;
	            
	            this.loading = true;
	            this.statusMessage = '刷新页面中';
	            this.$refs.externalFrame.contentWindow.location.reload();
	            this.addLog(`刷新页面: ${this.currentUrl}`);
	          },
	          onIframeLoad() {
	            this.loading = false;
	            this.statusMessage = '页面加载完成';
	            this.addLog('页面加载完成');
	            
	            try {
	              // 尝试跨域通信
	              this.$refs.externalFrame.contentWindow.postMessage({
	                type: 'handshake',
	                message: '来自宿主页面的问候'
	              }, '*');
	            } catch (e) {
	              this.addLog('跨域通信受限: ' + e.message);
	            }
	          },
	          onIframeError() {
	            this.loading = false;
	            this.statusMessage = '页面加载失败';
	            this.addLog('页面加载失败');
	          },
	          addLog(message) {
	            const timestamp = new Date().toLocaleTimeString();
				console.log("=============="+ message)
	          },
	          handleMessage(event) {
	            if (event.data && event.data.type) {
	              this.addLog(`收到消息: ${JSON.stringify(event.data)}`);
	            }
	          },
			  
    goUrl(item, isAuto) { 
      let url = item.wjUrl;
      let checkCount = '';
      if (url.indexOf('checkCount') >= 0) {
        checkCount = url.substring(url.indexOf('checkCount=') +11);
      }
      let title = item.title;
      let type = item.type;
      if (url) {
        if (title!='症候问卷' && title!='体质辨识问卷' && title!='中医证候调研问卷' && title!='体质辨识调研问卷') {
          // this.frameUrl = url;
		  location.href = url;
          this.showPage = true;
        } else {
          if (type == 1) {
            if (title == '症候问卷' || title == '中医证候调研问卷') {
              let info = item.zhData || item.tzData;
              location.href = this.zyUrl + `?id=${info.id}&gender=${info.gender}&name=${info.name}&studentId=${info.studentId}&birthday=${info.birthday ? info.birthday.substring(0, 10) : ''}&idCard=${info.idCard}&code=${info.code}&openId=${this.openId}&hospitalId=${item.hospitalId}&checkCount=${checkCount}`;
            }
            if (title == '体质辨识问卷' || title == '体质辨识调研问卷') {
              let info = item.tzData || item.zhData;
              location.href = this.tzUrl + `?id=${info.id}&gender=${info.gender}&name=${info.name}&studentId=${info.studentId}&birthday=${info.birthday? info.birthday.substring(0, 10):''}&idCard=${info.idCard}&code=${info.code}&openId=${this.openId}&hospitalId=${item.hospitalId}&checkCount=${checkCount}`;
            }
          }
          if (type == 0) {
            if (title == '症候问卷' || title == '中医证候调研问卷') {
              let info = item.zhData || item.tzData;
              if (isAuto) {
                location.href = this.zyListUrl + `?gender=${info.gender}&name=${info.name}&studentId=${info.studentId}&birthday=${info.birthday ? info.birthday.substring(0, 10) : ''}&idCard=${info.idCard}&code=${info.code}&openId=${this.openId}&hospitalId=${item.hospitalId}&checkCount=${checkCount}&uid=${this.uid}`;
              }else {
                location.href = this.zyListUrl + `?gender=${info.gender}&name=${info.name}&studentId=${info.studentId}&birthday=${info.birthday ? info.birthday.substring(0, 10) : ''}&idCard=${info.idCard}&code=${info.code}&openId=${this.openId}&hospitalId=${item.hospitalId}&checkCount=${checkCount}`;
              }
            }
            if (title == '体质辨识问卷' || title == '体质辨识调研问卷') {
              let info = item.tzData || item.zhData;
              if (isAuto) {
                location.href = this.tzListUrl + `?gender=${info.gender}&name=${info.name}&studentId=${info.studentId}&birthday=${info.birthday ? info.birthday.substring(0, 10) : ''}&idCard=${info.idCard}&code=${info.code}&openId=${this.openId}&hospitalId=${item.hospitalId}&checkCount=${checkCount}&uid=${this.uid}`;
              }else {
                location.href = this.tzListUrl + `?gender=${info.gender}&name=${info.name}&studentId=${info.studentId}&birthday=${info.birthday ? info.birthday.substring(0, 10) : ''}&idCard=${info.idCard}&code=${info.code}&openId=${this.openId}&hospitalId=${item.hospitalId}&checkCount=${checkCount}`;
              }
            }
          }
        }
      }
    },
    async goQuery(id) {
      this.ktwjUrlList = [];
      let result = await this.$http.get(this.$url.getWenJuanList, {
        studentId: id
      })
      let list = result.data.list;
      this.ktwjUrlList = list;
      if(this.ktwjUrlList.length === 1) {
        let item = this.ktwjUrlList[0];
        // location.href = item.wjUrl;
        this.goUrl(item, false)
      } else if (this.ktwjUrlList.length > 1){
        for (var i = 0; i < this.ktwjUrlList.length; i++) {
            console.log(this.ktwjUrlList[i]);
            let selectItem = this.ktwjUrlList[i]
            if (selectItem.wjUrl.indexOf('.yjkok.com') > -1 && selectItem.type === 0){
              //未做的
              this.goUrl(selectItem, true)
            }
        }
      }
    },
    onCloseDetail() {
      this.$router.push(`/questionnaire?openId=${this.$route.query.openId}&studentId=${this.$route.query.studentId}&fromDetail=true`);
    },
  }
};
</script>
<style scope lang="less">
.top {
  padding: 0.3rem;
  font-size: 0.32rem;
  font-weight: bold;
  border-bottom: 1px solid #dddddd;
}
.record {
  width: 100%;
  padding-bottom: 4rem;
  .record-list-item {
    div {
      height: 1rem;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      text-align: center;
      line-height: 1rem;
      border-bottom: 1px solid #dddddd;
    }
    &:nth-child(odd) {
      background: #eeeeee;
    }
  }
}

.url-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 100;
  line-height: 1.5em;
  text-align: center;
  background: rgba(0, 0, 0, 0.5);

  .mask {
    width: 90%;
    height: 8rem;
    // padding: 0 0 0.3rem;

    // overflow: auto;
    margin: 30% auto;
    background: #fff;
    border-radius: 5px;
    display: flex;
    flex-direction: column;
    .info-text {
      color: red;
      text-align: center;
      padding: 0.2rem;
      // margin-top: 22%;
    }
  }

  .mask-close {
    width: 100%;
    height: 0.5rem;

    img {
      width: 0.5rem;
      margin: 0.2rem;
      margin-left: 6rem;
    }
  }

  .url-title {
    width: 100%;
    padding-bottom: 0.2rem;
    font-weight: bold;
    border-bottom: 1px solid #ccc;
    font-size: 0.32rem;
    // height: 0.8rem;

  }

  .url-lists {
    flex: 1;
    overflow-y: auto;
  }
  .url-list {
    display: flex;
    justify-content: space-between;
    padding: 0.3rem 0.5rem;
    text-align: left;
    
    .list-title {
      width: 75%;
    }
 
    &:nth-child(odd) {
      background: #eee;
    }

    a {
      color: #333fcc;
    }
  }
}
.page-frame {
  position:absolute;
  top: 1vh;
  left: 1vw;
  z-index: 1000;
  width: 98vw;
  height: 98vh;
  border: 0;
  background-color: #fff;
  padding-bottom: 1vh;
}

.page-close {
  position:absolute;
  top: 2vh;
  right: 1vw;
  z-index: 1000;
  width: 100%;
  height: 0.5rem;

  img {
    width: 0.5rem;
    padding: 0.1rem 0.1rem 0.1rem;
    margin-left: 6.5rem;
    border-radius: 0.35rem;

    background: #fff;
  }
}

.r-query {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 2rem;
  line-height: 1rem;
  background: #fff;
  text-align: center;
}

.r-query .btn {
  width: 5.5rem;
  height: 1rem;
  margin: 0.4rem auto;
  color: #fff;
  border-radius: 5px;
  background: #5CC4AB;
}
</style>
